import { useLang } from "../../i18n/LangContext";
import { LegalPage, H2, P, UL } from "../../components/LegalPage";

export default function Cookies() {
  const { lang } = useLang();
  return (
    <LegalPage titlePl="Polityka cookies" titleEn="Cookie policy" lang={lang} testId="cookies-page">
      {lang === "pl" ? (
        <>
          <P>AI Dating Coach używa minimalnej ilości danych przechowywanych w przeglądarce. Nie używamy reklamowych cookies trackujących ani narzędzi do retargetingu.</P>

          <H2>1. localStorage (niezbędne)</H2>
          <UL>
            <li><code>dc_token</code> — JWT do utrzymania sesji po zalogowaniu. Usuwa się przy wylogowaniu.</li>
            <li><code>dc_lang</code> — wybrany język interfejsu (pl/en).</li>
            <li><code>dc_cookie_consent_v1</code> — Twoja decyzja co do cookies.</li>
          </UL>
          <P>Te dane są niezbędne do działania aplikacji i nie wymagają zgody zgodnie z art. 173 ust. 3 ustawy Prawo telekomunikacyjne.</P>

          <H2>2. Stripe (płatności)</H2>
          <P>Strona płatności Stripe (hostowana poza naszą domeną) używa własnych cookies do wykrywania fraudu i obsługi sesji płatniczej. Dotyczy ich polityka Stripe: <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#ff4458] underline">stripe.com/privacy</a>.</P>

          <H2>3. Brak analityki i reklam</H2>
          <P>Nie używamy Google Analytics, Facebook Pixel, ani żadnych narzędzi reklamowych. Nie sprzedajemy ani nie udostępniamy danych marketingowych.</P>

          <H2>4. Jak zarządzać</H2>
          <P>Możesz wyczyścić localStorage w ustawieniach przeglądarki w dowolnym momencie. Spowoduje to wylogowanie i reset preferencji.</P>
        </>
      ) : (
        <>
          <P>AI Dating Coach uses a minimal amount of browser-stored data. We do not use tracking or advertising cookies.</P>

          <H2>1. localStorage (essential)</H2>
          <UL>
            <li><code>dc_token</code> — JWT for session persistence after login. Removed on logout.</li>
            <li><code>dc_lang</code> — selected UI language (pl/en).</li>
            <li><code>dc_cookie_consent_v1</code> — your cookie decision.</li>
          </UL>
          <P>These are essential for the app to function and do not require consent under EU/Polish law.</P>

          <H2>2. Stripe (payments)</H2>
          <P>Stripe&apos;s hosted checkout page (off our domain) uses its own cookies for fraud detection and session handling. Subject to Stripe&apos;s policy: <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#ff4458] underline">stripe.com/privacy</a>.</P>

          <H2>3. No analytics or ads</H2>
          <P>We do not use Google Analytics, Facebook Pixel, or any ad tools. We do not sell or share marketing data.</P>

          <H2>4. How to manage</H2>
          <P>You can clear localStorage in your browser settings at any time. This will log you out and reset preferences.</P>
        </>
      )}
    </LegalPage>
  );
}
